import React from "react";
import {
  Box,
  Text,
  Select,
  FormControl,
} from "@chakra-ui/react";
import { Loading } from "../components/Loading";

interface AppointmentGroupSelectorProps {
  appointmentGroups: { appointment_group_id: string, name: string, is_default: boolean, is_active: boolean }[];
  selectedAppointmentGroup: string | null;
  handleAppointmentGroupChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  appointmentGroupsLoading: boolean;
  appointmentGroupsError: any;
}

const AppointmentGroupSelector: React.FC<AppointmentGroupSelectorProps> = ({
  appointmentGroups,
  selectedAppointmentGroup,
  handleAppointmentGroupChange,
  appointmentGroupsLoading,
  appointmentGroupsError,
}) => {
  return (
    <FormControl display="flex" justifyContent="center" mt={4}>
      <Box
        width="100%"
        overflowX="hidden"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexDirection={{ base: "column", lg: "row" }}
          width="100%"
          overflowX="hidden"
          gap={3}
        >
          <Box display="flex" alignItems="center" gap="2" w={"100%"}>
            <Text fontSize="sm" fontWeight="bold">
              Appointment type:
            </Text>
            {appointmentGroupsLoading ? (
              <Loading />
            ) : appointmentGroupsError ? (
              <Text color="red.500">
                Error loading appointment types
              </Text>
            ) : (
              <Select
                size="md"
                borderRadius="30px"
                value={selectedAppointmentGroup || ""}
                onChange={handleAppointmentGroupChange}
              >
                {appointmentGroups.map(aptGroup => (
                  <option
                    key={`${aptGroup.appointment_group_id}`}
                    value={aptGroup.appointment_group_id}
                  >
                    {aptGroup.name}
                  </option>
                ))}
              </Select>
            )}
          </Box>
        </Box>
      </Box>
    </FormControl>
  );
};

export default AppointmentGroupSelector;